<template>
    <div class="inner-box">
        <div class="content-name">
            <h2 class="dp-ib">해피콜관리{{ tabName }}</h2>
        </div>
        <!-- <button @click="next">{{$refs.step}}다음</button>
        <Step ref="steps" :active="nextIdx" :steps="steps"></Step> -->
        <tabs :tab="tab" :active-btn="active" @changeTab="changeTab"/>
        <component ref="cmpTab" v-bind:is="viewer" :custParam="custParam"/>

    </div>
</template>

<script>

/* TEST */
import Step from '@/components/elementUI/Step/index.vue';

/* Tab 구분 컴포넌트 */
import tabs from '@/components/AS/Tabs/index.vue';
import subTab1 from '@/components/AS/HappycallMng/subTab1.vue';
import subTab2 from '@/components/AS/HappycallMng/subTab2.vue';
import subTab3 from '@/components/AS/HappycallMng/subTab3.vue';

export default {
    components: {Step, tabs, subTab1, subTab2, subTab3},
    data() {
        return {
            drawer: false,
            direction: 'ttb',
            data: [],
            viewer: 'subTab1',
            orgTab:[
                {tabId: 'subTab1', tabName:'기본정보', tabCss:"btn btn-primary", tabNo:'0', tabShow: true},
                {tabId: 'subTab2', tabName:'캠페인대상자', tabCss:"btn btn-outline-primary", tabNo:'1', tabShow: true},/** 'btn btn-nonActive'버튼 비활성화 class */
                {tabId: 'subTab3', tabName:'상담원분배', tabCss:"btn btn-outline-primary", tabNo:'2', tabShow: true}
            ],
            tab:[],
            search: {
                custNm: "",
                custId: "",
                custType: "",
                custGb: "1",
                codeNm: "",
                useType: "Y",
                inType: "", /** 유입경로 */
                inTypeVal: "" /** 유입경로 값*/
            },
            active: true,
            nextIdx: 1,
            steps: [{
                title: 'Step 1'
                ,description: ''
            },
            {
                title: 'Step 2'
                ,description: ''
            },
            {
                title: 'Step 3'
                ,description: ''
            }],
            grants: {},
            custParam:{},
            inType: '', /** 유입경로 */
            inTypeVal: '' /** 유입경로 값 */
        }
    },
    computed: {
        routeName() {
            return this.$route.name
        },
        getGrants() {
            const {grantDelete, grantInsert, grantPrint, grantSelect, grantUpdate} = this.$menu.getGrants();
            return {grantDelete, grantInsert, grantPrint, grantSelect, grantUpdate}
        },
        tabName() {
            return this.orgTab.filter(f => f.tabId == this.viewer).length > 0 ? `(${this.orgTab.filter(f => f.tabId == this.viewer)[0]?.tabName})` : '';
        }
    },
    created() {
        this.tab = _.cloneDeep(this.orgTab);

        this.$store.commit("setHeaderTitle", {
            headerComponentName: this.head,
            routeName: this.routeName,
            isMobile: this.$device.isMobile()
        });
    },
    mounted() {
        this.grants = this.$menu.getGrants();
        console.log('mounted this.$route.path : ', this.$route);

        if(this.$route.path === '/HappycallInfoTab2'){
            const params = {
                ...this.$route.params
            };

            this.reloadPage(params, 'HappycallInfoTab');
        }

console.log('mounted this.$route.params.tabId : ', this.$route.params.tabId);
        if(this.$route.params.tabId === 'subTab2'){
            this.viewer = this.$route.params.tabId;

            this.tab[0].tabCss = 'btn btn-outline-primary';
            this.tab[1].tabCss = 'btn btn-primary';
            this.tab[2].tabCss = 'btn btn-outline-primary';
            
            this.tab[1].tabShow = true; // 캠페인대상자

        } else if(this.$route.params.tabId === 'subTab3'){    
            this.viewer = this.$route.params.tabId;
            console.log('mounted this.$route.params.tabId : ', this.viewer);
            this.tab[0].tabCss = 'btn btn-outline-primary';
            this.tab[1].tabCss = 'btn btn-outline-primary';
            this.tab[2].tabCss = 'btn btn-primary';
            
            this.tab[2].tabShow = true; // 상담원분배

        } else {
            this.viewer = this.$route.params.tabId;

            this.tab[0].tabCss = 'btn btn-primary';
            this.tab[1].tabCss = 'btn btn-outline-primary';
            this.tab[2].tabCss = 'btn btn-outline-primary';
            
            this.tab[0].tabShow = true; // 기본정보

        }
    },
    methods: {
        save() {
            
        },
        changeTab(params) {
            this.viewer = params.tabId;
        },
        searchContentInTab(param){
            
            // this.histList = param.callAsCustSelPageList || []
            // this.custInfo = param.callCustSelItemList || {}
            console.log(' cmpTab ref: ', this.$refs.cmpTab)
            this.custParam = {
                ...param
             } || {}

            if(this.viewer === 'subTab1') {
                this.$refs.cmpTab.setNormalList(param.tab1AsAgentSelItem || {});
            } else if(this.viewer === 'subTab2') {
                this.$refs.cmpTab.setNormalList(param.tab2ServiceEngineerSelAgent || []);
            } else if(this.viewer === 'subTab3') {
                console.log('this.viewer 3: ', param.tab3AsAgentSelItem, param);
                this.$refs.cmpTab.setNormalList(param.tab3AsAgentSelItem || []);
            }
        },
        handleClose(done) {
            this.$confirm('Are you sure you want to close this?')
            .then(_ => {
                done();
            })
            .catch(_ => {});
        },
        next() {
            console.log('AsMng next() start')
            if (this.nextIdx++ > this.steps.length-1) {
                this.nextIdx = 1;
            }
            //console.log(this.$refs.steps.$refs)
            if(this.nextIdx === 1) {
                console.log(`step1`,this.$refs.steps.$refs.step3)
            } else if(this.nextIdx === 2) {
                console.log(`step2`, this.$refs.steps.$refs.step1)
            } else if(this.nextIdx === 3) {
                console.log(`step3`, this.$refs.steps.$refs.step2)
            }
            return this.nextIdx;
        },
        reloadPage(params, vName){

            console.log('reloadPage : ', params);
            let vRouterName = 'HappycallInfoTab2';
            if(vName){
                vRouterName = vName;
            }

            this.$router.push({          
                name: vRouterName,
                params: {
                    tabId: 'subTab1',
                    detailLinkYn: 'Y', /** 상세페이지 링크 클릭여부 : 입력/수정 구분하기위해 */
                    campaignId: params.campaignId,
                    startDt: params.startDt || this.$moment().format('YYYY-MM-DD'),
                    endDt: params.startDt || this.$moment().format('YYYY-MM-DD')
                }
            });
        }
    }
}
</script>